import initialActivityTypesData from '../data/initialActivityTypesData'
import initialNotesData from '../data/initialNotesData'
import initialSettingsData from '../data/initialSettingsData'
import initialTrackedRoutesData from '../data/initialTrackedRoutesData'

/* eslint-disable no-console */

/**
 * Check if database / database store updates are needed when indexeddb version is increased
 *
 * @param e The IDB update request object with the database name
 *
 * @todo: Add updateOnesettingAfterUpdate to add pagination data!!!
 */
const checkIfUpdateIsNeeded = e => {
  console.groupCollapsed('CHECK IF UPDATE IS NEEDED FOR v1')

  // Set the db variable to our database so we can use it!
  const db = e.target.result

  /**
   * ----- ObjectStore "Settings"
   */
  if (!db.objectStoreNames.contains('settings')) {
    // Create an object store named notes. Object stores
    // in databases are where data are stored.
    const settingsStore = db.createObjectStore('settings', { autoIncrement: true })

    // Add initial data by getting the current transaction
    const txn = e.target.transaction
    const addRequest = txn.objectStore('settings').add(initialSettingsData)

    console.info('onupgradeneeded: store "settings" created')
  }
  else {
    console.info('onupgradeneeded: store "settings" already exists')
  }

  // // FOR DEVELPMENT ONLY!!!
  // // RESET "SETTINGS" STORE (e.g. because a param got renamed or was removed)
  // // 1. delete settings store from indexeddb
  // // 2. Uncomment code below
  // // 3. increase DB version in indexeddb.js
  // // Save should automatically reload the website and setup the Store anew again.
  // const txn = e.target.transaction
  // const addRequest = txn.objectStore('settings').add(initialSettingsData)

  /**
   * ----- ObjectStore "Activity Types"
   */
  if (!db.objectStoreNames.contains('activityTypes')) {
    // Create object store
    const activityTypesStore = db.createObjectStore('activityTypes', { autoIncrement: true, keyPath: 'id' })

    // Create indexes
    activityTypesStore.createIndex('title', 'title', { unique: true })

    // Add initial data by getting the current transaction
    const txn = e.target.transaction
    initialActivityTypesData.forEach(activity => {
      const addRequest = txn.objectStore('activityTypes').add(activity)
    })

    console.info('onupgradeneeded: store "activityTypes" created')
  }
  else {
    console.info('onupgradeneeded: store "activityTypes" already exists')
  }

  /**
   * ----- ObjectStore "TrackedRoutes" (previous "activities")
   */
  if (!db.objectStoreNames.contains('trackedRoutes')) {
    const store = db.createObjectStore('trackedRoutes', { autoIncrement: true, keyPath: 'id' })

    // Create indexes
    store.createIndex('date', 'date', { unique: true })
    store.createIndex('distanceKm', 'distanceKm', { unique: false })
    store.createIndex('distanceM', 'distanceM', { unique: false })
    store.createIndex('durationStartStop', 'durationStartStop', { unique: false })
    store.createIndex('steps', 'steps', { unique: false })
    store.createIndex('title', 'title', { unique: false })
    store.createIndex('typeTitle', 'typeTitle', { unique: false })
    // Maybe we will add: duration, distance, steps
    // But to do that, we need to change the way the data is saved: All "properties"
    // must be saved on the root level, too!

    // Add initial data by getting the current transaction
    const txn = e.target.transaction

    const exampleData = initialTrackedRoutesData
    exampleData.forEach(note => {
      const addRequest = txn.objectStore('trackedRoutes').add(note)
    })

    console.info('onupgradeneeded: store "trackedRoutes" created')
  }
  else {
    console.info('onupgradeneeded: store "trackedRoutes" already exists')
  }

  /**
   * ----- ObjectStore "Notes"
   */
  if (!db.objectStoreNames.contains('notes')) {
    const notesTypesStore = db.createObjectStore('notes', { autoIncrement: true, keyPath: 'id' })
    notesTypesStore.createIndex('title', 'title', { unique: false })
    notesTypesStore.createIndex('text', 'text', { unique: false })
    notesTypesStore.createIndex('createdAt', 'createdAt', { unique: true })
    // Add initial data by getting the current transaction
    const txn = e.target.transaction
    const notes = initialNotesData
    notes.forEach(note => {
      const addRequest = txn.objectStore('notes').add(note)
    })
    console.info('onupgradeneeded: store "notes" created')
  }
  else {
    console.info('onupgradeneeded: store "notes" already exists')
  }

  console.groupEnd()
}

export default checkIfUpdateIsNeeded
